export const gradeOptions = [
  { value: null, text: '未設定' },
  { value: 7, text: '中学1年' },
  { value: 8, text: '中学2年' },
  { value: 9, text: '中学3年' },
  { value: 10, text: '高校1年' },
  { value: 11, text: '高校2年' },
  { value: 12, text: '高校3年' },
]

export const homeroomOptions = [
  { value: null, text: '未設定' },
  ...['1', '2', '3', '4', '5', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'V', 'S', 'T'].map(v => ({ value: v, text: v }))
]

export const attendanceNumberOptions = [
  { value: null, text: '未設定' },
  ...[...Array(50).keys()].map(i => ({ value: i + 1, text: String(i + 1) }))
]
